var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SceenerFilter"},[_c('Dropdown',{attrs:{"options":_vm.options,"value":_vm.selectedOption,"name":""},on:{"on-update":_vm.onOptionsSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }